<span style="font-size: 1.2em; font-weight: bold;" class="d-block">{{ step3.getspan2  | translate }}</span>
<br />

<app-typeCPV-class
	[uid]="getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"

	[objetPrincipal]="cPV?.objetPrincipal"
></app-typeCPV-class>
